import initialState from './state';
import { DATA_ACTION_TYPES } from './actions';
import { isDiscountTariff } from '../../utils/scripts/parseTariff';

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case DATA_ACTION_TYPES.SET_PAYMENT_PRODUCT:
      const data = JSON.parse(action.payload);
      return {
        ...state,
        paymentModal: {
          ...state.paymentModal,
          product: {
            ...state.paymentModal.product,
            name: data.product,
            details: {
              ...action.details,
              oldPrice: data.oldPrice,
            },
          },
          productName: {
            ...action.name,
            name: data.name,
          }
        },
      };

    case DATA_ACTION_TYPES.SET_PRODUCT_ON_INIT_SCREEN:
      return {
        ...state,
        productOnInitScreen: {
          ...state.productOnInitScreen,
          name: action.payload.name,
          details: action.payload.details,
        },
      };

    case DATA_ACTION_TYPES.SET_PAYMENT_CARD_BRAND:
      return {
        ...state,
        paymentCardBrand: action.payload,
      };

    case DATA_ACTION_TYPES.CLEAN_STRIPE_ERRORS:
      return {
        ...state,
        stripeErrorsCreared: action.payload,
      };

    case DATA_ACTION_TYPES.SET_TARIFF:
      return {
        ...state,
        tariff: action.payload,
        isDiscount: isDiscountTariff(action.payload),
      };
    case DATA_ACTION_TYPES.SET_DIGITAL_PRODUCT:
      return {
        ...state,
        productList: action.payload,
      };
    case DATA_ACTION_TYPES.SET_PAYMENT_FREE_BONUS:
      return {
        ...state,
        paymentModal: {
          ...state.paymentModal,
          withFreeBonus: action.payload,
        },
      };
    default:
      return state;
  }
};

export default reducer;
